import React from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';

interface Props {
  routeLink: string;
}

export const NoBillingProfileWarningPanel = ({ routeLink }: Props) => {
  return (
    <SectionMessage
      title="Update billing profile"
      appearance="warning"
      actions={[
        <SectionMessageAction key="billing" href={routeLink}>
          Add billing profile
        </SectionMessageAction>,
      ]}
    >
      <p>Subscription changes can't be made because there's:</p>
      <br />
      <p>No billing profile available</p>
      <br />
      <p>
        Add billing profile, then try again. Still having trouble? Contact the <strong>#help-advocate-central</strong>{' '}
        channel
      </p>
    </SectionMessage>
  );
};
